<template>
  <div>
    <vx-card class="mt-base mb-5" title="Learning & Resources">
      <h4 class="mb-5">What is Engineering?</h4>
      <p class="mb-5">
        The results of engineering and engineers can be seen all around us, but do you know what the
        work “Engineering” actually means?
      </p>
      <p class="mb-5">Find out in this fun, fact-packed video:</p>
      <responsive-youtube-wrapper :video="videos[1].video" :image="videos[1].image" class="mb-5" />
      <p class="mb-5">
        So, now that you have an overview of the different types of engineering, lets look more
        closely at the fields that we will cover in this Virtual Job Experience.
      </p>

      <h4 class="mb-5">Civil Engineering:</h4>
      <responsive-youtube-wrapper :video="videos[2].video" :image="videos[2].image" class="mb-5" />
      <h4 class="mb-5">Mechanical Engineering:</h4>
      <responsive-youtube-wrapper :video="videos[3].video" :image="videos[3].image" class="mb-5" />
      <h4 class="mb-5">Electrical Engineering</h4>
      <responsive-youtube-wrapper :video="videos[4].video" :image="videos[4].image" class="mb-5" />
      <h4 class="mb-5">Chemical Engineering</h4>
      <responsive-youtube-wrapper :video="videos[5].video" :image="videos[5].image" class="mb-5" />
    </vx-card>
  </div>
</template>

<script>
import store from '@/store/store';

export default {
  data() {
    return {
      videos: {
        1: {
          video: 'https://www.youtube.com/embed/btGYcizV0iI',
          image: require('@/assets/images/experiences/engineering/what_is_engineering_splash.jpg'),
        },
        2: {
          video: 'https://www.youtube.com/embed/-xbtnz4wdaA',
          image: require('@/assets/images/experiences/engineering/civil_engineering_splash.jpg'),
        },
        3: {
          video: 'https://www.youtube.com/embed/A1V-QQ5wFU4',
          image: require('@/assets/images/experiences/engineering/mechanical_engineering_splash.jpg'),
        },
        4: {
          video: 'https://www.youtube.com/embed/3nB1Ntku06w',
          image: require('@/assets/images/experiences/engineering/electrical_engineering_splash.jpg'),
        },
        5: {
          video: 'https://www.youtube.com/embed/aRKyJRAxjpM',
          image: require('@/assets/images/experiences/engineering/chemical_engineering_splash.jpg'),
        },
      },
    };
  },
  computed: {
    activeExperienceID() {
      return store.getters['authStudent/activeExperienceID'];
    },
    experience() {
      const loginType = localStorage.getItem('login_type');
      if (loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.activeExperienceID);
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
  },
  beforeMount() {
    store.commit('authStudent/setActiveExperienceID', this.$route.params.id);
  },
};
</script>
